<template>
  <div>
    <v-alert v-if="isAcademyInactive" type="error" text prominent border="left" class="mb-4">
      {{ $t('message.admin_plus_academy_inactive_banner') }}
      <router-link v-if="!isAcademyInherited" :to="{ name: 'upgrade-plan-adminplus' }">
        {{ $t('message.admin_plus_update_payment_method') }}
      </router-link>
    </v-alert>
    <v-alert v-else-if="isAcademyPastDueGrace" type="warning" text prominent border="left" class="mb-4">
      {{ $t('message.admin_plus_past_due_banner', { days: academyDaysUntilInactive }) }}
      <router-link v-if="!isAcademyInherited" :to="{ name: 'upgrade-plan-adminplus' }">
        {{ $t('message.admin_plus_update_payment_method') }}
      </router-link>
    </v-alert>
    <v-card elevation="0" class="pl-0 pr-0">
      <v-card-actions class="border-light mx-4 px-4">
        <v-avatar size="50" class="ml-2">
          <ImageDisplay :src="$store.state.userImage" alt="avatar" />
        </v-avatar>
        <div class="pl-3">
          <div>
            <span class="mr-2">
              <v-icon size="20"
                v-if="greetingTime == 'morning' || greetingTime == 'afternoon'">mdi-weather-sunny</v-icon>
              <v-icon size="20" v-else>mdi-weather-night</v-icon>
            </span>

            <b><span>{{ $t("message.greeting_" + greetingTime) }}</span>,
              <span class="text-truncate" v-if="$store.state.user">{{ $store.state.user.fName }} {{
                $store.state.user.lName }}</span></b>
          </div>
          <div class="supporting-text">
            <v-icon class="mr-2" size="20">mdi-bank</v-icon>
            {{ academyName }}<span v-if="academyAffiliation">, {{ academyAffiliation }}</span>
          </div>
        </div>
        <v-spacer></v-spacer>
        <v-menu offset-y small v-if="!isSmallerDisplay()">
          <template v-slot:activator="{ on }">
            <v-btn class="mr-2" v-on="on" slot="activator" small outlined elevation="0">
              {{ $t("message.quick_actions") }}
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item v-if="isSmallerDisplay()" @click.stop="displaySocialPostDialog()">
              <v-list-item-title>
                {{ $t("message.bulletin_post") }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click.stop="goToQuickAction('add_event')">
              <v-list-item-title>
                {{ $t("message.add_event") }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click.stop="goToQuickAction('add_member')">
              <v-list-item-title>
                {{ $t("message.add_member") }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click.stop="goToQuickAction('manual_checkin')">
              <v-list-item-title>
                {{ $t("message.manual_checkin") }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click.stop="goToQuickAction('sell_item')">
              <v-list-item-title>
                {{ $t("message.sell_item") }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click.stop="goToQuickAction('sell_membership')">
              <v-list-item-title>
                {{ $t("message.sell_membership") }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item v-allowed="'view_expenses'" @click.stop="goToQuickAction('add_expense')">
              <v-list-item-title>
                {{ $t("message.add_expense") }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click.stop="goToQuickAction('referrals')">
              <v-list-item-title>
                {{ $t("message.referral_programs") }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn small elevation="0" v-if="!isSmallerDisplay()" @click="displaySocialPostDialog()" color="secondary"
          v-allowed="'permission_social_wall'">
          {{ $t('message.social_post') }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card elevation="0" v-if="isSmallerDisplay()">
      <v-card-title>
        <v-menu offset-y small>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" slot="activator" small block outlined elevation="0" color="primary">
              {{ $t("message.quick_actions") }}
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item v-allowed="'permission_social_wall'" v-if="isSmallerDisplay()"
              @click.stop="displaySocialPostDialog()">
              <v-list-item-title>
                {{ $t("message.social_post") }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click.stop="goToQuickAction('add_member')">
              <v-list-item-title>
                {{ $t("message.add_member") }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click.stop="goToQuickAction('sell_item')">
              <v-list-item-title>
                {{ $t("message.sell_item") }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click.stop="goToQuickAction('sell_membership')">
              <v-list-item-title>
                {{ $t("message.sell_membership") }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click.stop="goToQuickAction('manual_checkin')">
              <v-list-item-title>
                {{ $t("message.manual_checkin") }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item v-allowed="'view_expenses'" @click.stop="goToQuickAction('add_expense')">
              <v-list-item-title>
                {{ $t("message.add_expense") }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click.stop="goToQuickAction('referrals')">
              <v-list-item-title>
                {{ $t("message.referral_programs") }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-card-title>
    </v-card>
    <v-card elevation="0" class="pa-4">
      <v-card-title class="pa-0 text-subtitle-1">{{ $t('message.overview') }}</v-card-title>
      <v-row>
        <v-col cols="12" sm="4">
          <div class="card-overview">
            <v-card elevation="0" class="overview-card">
              <v-card-title class="text-subtitle-2 gray--text">
                {{ $t('message.last_new_members') }}
                <v-spacer></v-spacer>
                <div v-if="memberStats">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">{{ $t('message.this_month') }}: {{ memberStats.total }}</div>
                    </template>
                    <span>{{ $t('message.total_this_month') }}</span>
                  </v-tooltip>
                </div>
              </v-card-title>
              <v-skeleton-loader height="68" v-if="!newMembers" class="mx-auto" type="card">
              </v-skeleton-loader>
              <div v-else class="pa-2 text-center overflow-hidden">
                <v-tooltip bottom v-for="u of newMembers" :key="'newmember_' + u._id">
                  <template v-slot:activator="{ on, attrs }">
                    <v-avatar @click="goToMember(u.user._id)" v-bind="attrs" v-on="on" size="50"
                      class="ml-1 member-avatar">
                      <ImageDisplay v-if="u.user.userImageSmall" :src="u.user.userImageSmall" />
                      <img v-else :src="assets() + '/default-profile-avatar.png'" />
                    </v-avatar>
                  </template>
                  <span>{{ u.user.fName }} - {{ $d(new Date(u.created), "month_day_year", $i18n.locale) }}</span>
                </v-tooltip>
              </div>
              <v-card-actions color="gray" class="pa-0 action-card-main">
                <v-btn block elevation="0" color="primary" text @click="goToQuickAction('view_members')">
                  {{ $t('message.view_members') }}</v-btn>
              </v-card-actions>
            </v-card>
          </div>
        </v-col>
        <v-col cols="12" sm="4">
          <div class="card-overview">
            <v-card elevation="0" class="overview-card">
              <v-card-title class="text-subtitle-2 gray--text">
                {{ $t('message.last_checkins') }}
                <v-spacer></v-spacer>
                <v-tooltip bottom v-if="checkinStats && checkinStats.percent">
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip v-bind="attrs" v-on="on" small :color="checkinStats.percent >= 0 ? 'success' : 'error'">
                      <span class="mr-2 mb-1">
                        <v-icon size="17" class="mr-1"
                          v-if="checkinStats.percent < 0">mdi-arrow-down-drop-circle-outline</v-icon>
                        <v-icon size="17" class="mr-1" v-else>mdi-arrow-up-drop-circle-outline</v-icon>
                      </span>

                      {{ checkinStats.percent }}%
                    </v-chip>
                  </template>
                  <span>
                    {{ $t('message.same_time_last_month') }}: {{ checkinStats.lastMonth }} vs {{ checkinStats.today }}
                  </span>
                </v-tooltip>
              </v-card-title>
              <v-skeleton-loader height="68" v-if="!lastCheckins" class="mx-auto" type="card">
              </v-skeleton-loader>
              <div v-else-if="lastCheckins.length == 0" class="pa-2 text-center pt-5">
                <v-icon color="gray" size="40">mdi-cancel</v-icon>
              </div>
              <div v-else class="pa-2 text-center overflow-hidden">
                <v-tooltip bottom v-for="u of lastCheckins" :key="'checkin_' + u._id">
                  <template v-slot:activator="{ on, attrs }">
                    <v-avatar @click="goToMember(u.user._id)" v-bind="attrs" v-on="on" size="50"
                      class="ml-1 member-avatar">
                      <ImageDisplay v-if="u.user.userImageSmall" :src="u.user.userImageSmall" />
                      <img v-else :src="assets() + '/default-profile-avatar.png'" />
                    </v-avatar>
                  </template>
                  <span>{{ u.user.displayName }}</span>
                </v-tooltip>
              </div>
              <v-card-actions color="gray" class="pa-0 action-card-main">
                <v-btn block color="primary" elevation="0" class="mb-0" text
                  @click="goToQuickAction('view_attendance')">
                  {{ $t('message.view_attendance') }}</v-btn>
              </v-card-actions>
            </v-card>
          </div>
        </v-col>
        <v-col cols="12" sm="4">
          <div class="card-overview">
            <v-card elevation="0" class="overview-card">
              <v-card-title class="text-subtitle-2 gray--text">
                {{ $t('message.income_this_month') }}
                <v-spacer></v-spacer>
                <v-tooltip bottom v-if="incomeThisMonthLastUpdate">
                  <template v-slot:activator="{ on, attrs }">
                    <span class="text-caption" v-bind="attrs" v-on="on">{{
                      $d(new
                        Date(incomeThisMonthLastUpdate), 'long',
                        $i18n.locale) }}</span>
                  </template>
                  <span>
                    {{ $t('message.last_update') }}
                  </span>
                </v-tooltip>
              </v-card-title>
              <div style="min-height: 68px">
                <div v-allowed="'view_income'">
                  <v-skeleton-loader height="68" v-if="loadingIncome" class="mx-auto" type="card">
                  </v-skeleton-loader>
                  <v-row v-else>
                    <v-col>
                      <div style="height: 68px" v-if="incomeThisMonth == 0" class="pa-2 text-center overflow-hidden">
                        <span class="supporting-text mt-4">{{ $t('message.no_income_to_report')
                        }}</span>
                      </div>
                      <div v-else class="pa-2 text-center">
                        <span class="text-h3 gray--text">{{ currencySymbol }}{{ isSmallerDisplay() ?
                          formatNumberWithK(incomeThisMonth) : incomeThisMonth }}</span>
                      </div>
                    </v-col>
                    <v-col>
                      <div v-if="incomeSpline.options" style="height:45px;">
                        <ApexChart style="margin-top:-30px" type="line" :options="incomeSpline.options" height="100"
                          :series="incomeSpline.data">
                        </ApexChart>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </div>
              <v-card-actions color="gray" class="pa-0 action-card-main" v-allowed="'view_income'">
                <v-btn block elevation="0" color="primary" class="mb-0" text
                  @click="goToQuickAction('view_transactions')">
                  {{ $t('message.view_transactions') }}</v-btn>
              </v-card-actions>
            </v-card>
          </div>
        </v-col>
      </v-row>
    </v-card>
    <v-card v-allowed="'view_purchases'" elevation="0" class="pa-4">
      <v-card-title class="pa-0 text-subtitle-1">{{ $t('message.recent_activity') }}</v-card-title>
      <v-card flat outlined class="pa-0" elevation="0">
        <v-data-table class="elevation-0" outlined item-key="_id" :headers="recentTransactionsHeaders"
          :items="recentTransactions" :loading="loadingTransactions" :items-per-page="5"
          :no-data-text="$t('message.no_data')" :footer-props="{
            itemsPerPageText: $t('message.rows_per_page'),
          }">
          <template v-slot:top>
            <v-card-actions class="pa-0">
              <v-spacer></v-spacer>
              <v-btn icon @click="refreshRecentTransactions()">
                <v-icon :class="loadingTransactions ? 'rotate' : ''">mdi-sync</v-icon>
              </v-btn>
            </v-card-actions>
          </template>
          <template v-slot:item.buyer="{ item }">
            <span class="mr-2">
              <v-icon size="20" v-if="item.amount < 0">mdi-credit-card-minus-outline</v-icon>
              <v-icon size="20" v-else-if="item.cash">mdi-cash-100</v-icon>
              <v-icon size="20" v-else-if="item.subscription">mdi-sync</v-icon>
              <v-icon size="20" v-else>mdi-credit-card-outline</v-icon>
            </span>
            <span v-if="item.expense" class="gray--text">{{ $t('message.expenses', [item.buyer ? item.buyer.displayName
              :
              item.email]) }}</span>
            <span v-else class="gray--text">{{ $t('message.payment_from', [item.buyer ? item.buyer.displayName :
              item.email]) }}</span>
            <span @click="goToTransaction(item.transactionId)" v-if="item.title && item.transactionId"
              class="ml-1 gray--text clickable">- {{ item.title }}</span>
            <span v-else-if="item.title" class="ml-1 gray--text">- {{ item.title }}</span>
          </template>
          <template v-slot:item.amount="{ item }">
            <span class="font-weight-black">{{ currencySymbol }}{{ item.amount ? item.amount.toFixed(2) : 0 }}</span>
          </template>
          <template v-slot:item.status="{ item }">
            <v-chip :color="getTransactionStatusColor(item.status)" small>{{ getTransactionStatusText(item.status) }}
            </v-chip>
          </template>
          <template v-slot:item.date="{ item }">
            <span class="gray--text">{{ $d(new Date(item.date), "month_day_year", $i18n.locale) }}</span>
          </template>
        </v-data-table>
      </v-card>
    </v-card>
    <v-card elevation="0" class="pa-4">
      <v-card-title class="pa-0 text-subtitle-1">{{ $t('message.demographics') }}</v-card-title>
      <v-row>
        <v-col cols="12" sm="6">
          <v-card elevation="0" outlined>
            <v-skeleton-loader v-if="!beltsGraph" class="mx-auto" type="card">
            </v-skeleton-loader>
            <div v-else class="pa-2 text-center demographics-card">
              <ApexChart v-if="beltsGraph && beltsGraph.options" type="bar" :options="beltsGraph.options" height="250"
                :series="beltsGraph.data"></ApexChart>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6">
          <v-card elevation="0" outlined>
            <v-skeleton-loader v-if="!typesGraph" class="mx-auto" type="card">
            </v-skeleton-loader>
            <div v-else class="pa-2 text-center demographics-card">
              <ApexChart v-if="typesGraph && typesGraph.options" type="donut" :options="typesGraph.options" height="250"
                :series="typesGraph.data"></ApexChart>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-card>

    <!-- MEI Widget -->
    <v-card elevation="0" class="pa-4 mt-2">
      <v-card-title class="pa-0 text-subtitle-1">{{ $t('message.member_engagement_index') }}</v-card-title>
      <v-skeleton-loader v-if="meiData === null" type="card" class="mx-auto mt-2"></v-skeleton-loader>
      <v-row v-else style="align-items:stretch;">
        <!-- Left: radial chart + explanation -->
        <v-col cols="12" sm="6" class="d-flex flex-column">
          <v-card elevation="0" outlined class="flex-grow-1 d-flex flex-column">
            <div class="flex-grow-1 d-flex align-center justify-center">
              <div v-if="meiData.avgMei === null" class="text-center pa-6 grey--text">
                <v-icon size="48" color="grey lighten-2">mdi-chart-donut</v-icon>
                <div class="text-caption mt-2">{{ $t('message.no_data_available') }}</div>
              </div>
              <ApexChart v-else-if="meiChartOptions" type="radialBar" :options="meiChartOptions"
                :series="[meiData.avgMei]" height="220" width="100%"></ApexChart>
            </div>
            <div class="px-3 pb-3">
              <p class="text-caption grey--text mb-0">{{ $t('message.mei_explanation') }}</p>
            </div>
          </v-card>
        </v-col>

        <!-- Right: top performers -->
        <v-col cols="12" sm="6" class="d-flex flex-column">
          <v-card elevation="0" outlined class="flex-grow-1 d-flex flex-column">
            <v-card-subtitle class="pa-3 pb-1 font-weight-medium">
              {{ $t('message.top_performers') }}
            </v-card-subtitle>
            <v-list dense class="flex-grow-1" v-if="meiData.topPerformers && meiData.topPerformers.length">
              <v-list-item v-for="performer in meiData.topPerformers" :key="performer._id">
                <v-list-item-avatar size="36">
                  <member-avatar :image="performer.userImageSmall" :name="performer.name" size="36"></member-avatar>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="body-2">{{ performer.name }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-chip x-small dark :color="meiColor(performer.meiScore)">{{ performer.meiScore }}</v-chip>
                </v-list-item-action>
              </v-list-item>
            </v-list>
            <div v-else class="flex-grow-1 d-flex align-center justify-center grey--text pa-4">
              <span class="text-caption">{{ $t('message.no_data_available') }}</span>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-card>

    <v-dialog v-model="socialPostDialog" max-width="90%">
      <v-card v-if="socialPost" class="pt-6">
        <v-card-text>
          <h2 class="mt-4 mb-2">{{ $t('message.bulletin_post') }}</h2>
          <div class="supporting-text">{{ $t('message.social_post_explained') }}</div>
        </v-card-text>
        <v-card-text>
          <v-textarea :label="$t('message.contents')" outlined v-model="socialPost.contents" rows="3" maxlength="750">
          </v-textarea>
          <div class="supporting-text">
            {{ $t("message.you_can_delete_in_social") }}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn :disabled="socialPost.image != null || socialPost.videoObj != null" outlined small color="primary"
            elevation="0" @click="showOptions('poll')">
            <v-icon size="20">mdi-chart-box-outline</v-icon>
            <span v-if="!isSmallerDisplay()" class="ml-1">{{ $t("message.add_poll") }}</span>
          </v-btn>
          <v-btn :disabled="createPoll || socialPost.videoObj != null" small color="primary" outlined elevation="0"
            @click="addPostImage()">
            <v-icon size="20">mdi-image-outline</v-icon>
            <span v-if="!isSmallerDisplay()" class="ml-1">{{ $t("message.add_image") }}</span>
          </v-btn>
          <v-btn :disabled="createPoll" small color="primary" outlined elevation="0" @click="showOptions('video')">
            <v-icon size="20">mdi-video-outline</v-icon>
            <span v-if="!isSmallerDisplay()" class="ml-1">{{ $t("message.add_video") }}</span>
          </v-btn>
          <v-btn :disabled="createPoll" small color="primary" outlined elevation="0" @click="showOptions('event')">
            <v-icon size="20">mdi-calendar-month-outline</v-icon>
            <span v-if="!isSmallerDisplay()" class="ml-1">{{ $t("message.add_event") }}</span>
          </v-btn>
          <input type="file" ref="addPostImageEl" v-show="false" @change="uploadNewImage" accept="image/*" />
        </v-card-actions>
        <v-progress-linear class="mb-1" v-if="uploadingImage" indeterminate color="secondary"></v-progress-linear>
        <v-card-text v-if="socialPost.image" class="text-center">
          <v-responsive class="text-center">
            <ImageDisplay style="margin-left:auto;margin-right:auto" width="235" :src="socialPostImage"
              v-if="socialPostImage"></ImageDisplay>
          </v-responsive>
          <v-btn class="mt-1" elevation="0" v-if="socialPost.image" fab small
            @click="removePostImage()"><v-icon>mdi-trash-can-outline</v-icon></v-btn>
        </v-card-text>
        <v-card-text elevation="0" v-if="createPoll">
          <div>
            <v-card outlined elevation="0" class="pa-2" v-if="poll">
              <v-card-title style="margin-bottom:-25px">
                <v-icon class="mr-1">mdi-chart-box-outline</v-icon>
                {{ $t('message.poll') }}
              </v-card-title>
              <v-card-text>
                <v-text-field v-model="poll.question" :label="$t('message.question')" maxlength="60"></v-text-field>
              </v-card-text>
              <v-card-text style="margin-top:-35px">
                <v-text-field :key="'poll_answer_' + index" v-for="(i, index) in poll.answers"
                  v-model="poll.answers[index]" :label="$t('message.answer') + ' ' + (index + 1)" maxlength="40">
                </v-text-field>
              </v-card-text>
              <v-card-actions class="pa-1" v-if="poll.question && poll.answers.length < 5">
                <v-btn outlined class="elevation-0" color="primary" small @click="addPollAnswer()">
                  <v-icon class="mr-1">mdi-plus-circle-outline</v-icon>
                  {{ $t('message.answer') }}
                </v-btn>
              </v-card-actions>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn icon small @click="showOptions()"><v-icon>mdi-trash-can-outline</v-icon></v-btn>
              </v-card-actions>
            </v-card>
          </div>
        </v-card-text>
        <v-card-text v-if="addPostVideo">
          <v-autocomplete :label="$t('message.notes_video')" :items="videos" item-text="title" item-value="_id"
            v-model="socialPost.videoObj" hide-details clearable outlined dense></v-autocomplete>
        </v-card-text>
        <v-card-text v-if="addPostEvent">
          <v-autocomplete :disabled="socialPost.scheduleClassId" :loading="loadingEvents" class="mb-1"
            :label="$t('message.event')" :items="availableEvents" item-text="title" item-value="_id"
            v-model="socialPost.eventId" hide-details clearable outlined dense></v-autocomplete>
        </v-card-text>
        <v-card-text v-if="isSmallerDisplay()">
          <v-btn outlined block class="mt-1" small elevation="0" color="primary" @click="submitSocialPost()">{{
            $t("message.share") }}</v-btn>
          <v-btn block small elevation="0" class="mt-1" @click="closeSocialPostDialog()">
            {{ $t("message.close") }}</v-btn>
        </v-card-text>
        <v-card-actions v-else>
          <v-btn :disabled="uploadingImage" outlined small elevation="0" color="primary" @click="submitSocialPost()">{{
            $t("message.share")
          }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn small elevation="0" @click="closeSocialPostDialog()">
            {{ $t("message.close") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api2 from "@/services/Api2";
import ApexChart from 'vue-apexcharts';
import MemberAvatar from "@/components/displays/MemberAvatar.vue";

export default {
  data() {
    return {
      greetingTime: null,
      academyName: null,
      academyAffiliation: null,
      postImageToUpload: null,
      socialPostDialog: false,
      socialPost: null,
      currencySymbol: null,
      currency: null,
      lastCheckins: null,
      checkinStats: null,
      incomeThisMonth: 0,
      incomeSpline: {},
      uploadingImage: false,
      socialPostImage: null,
      incomeGraph: null,
      incomeGraphOptions: null,
      beltsGraph: null,
      typesGraph: null,
      meiData: null,
      meiChartOptions: null,
      addPostVideo: false,
      incomeThisMonthLastUpdate: null,
      addPostEvent: false,
      availableEvents: null,
      loadingEvents: false,
      newMembers: null,
      videos: [],
      memberStats: null,
      loadingTransactions: true,
      loadingIncome: true,
      recentTransactions: [],
      recentTransactionsHeaders: [
        { text: this.$t("message.transaction"), value: "buyer" },
        { text: this.$t("message.amount"), value: "amount" },
        { text: this.$t("message.status"), value: "status" },
        { text: this.$t("message.date"), value: "date" },
      ],
      createPoll: false,
      poll: {
        answers: ['', '']
      },
      mediaRules: [
        (v) => !v || v.size < 9000000 || "Image should be less than 9MB",
      ],
    };
  },
  components: {
    ApexChart,
    MemberAvatar,
  },
  computed: {
    isAcademyInactive() {
      const status = this.$store.state.academyAdminStatus;
      return !!(status && status.isActive === false);
    },
    isAcademyPastDueGrace() {
      const status = this.$store.state.academyAdminStatus;
      return !!(status && status.isPastDueGrace);
    },
    academyDaysUntilInactive() {
      const status = this.$store.state.academyAdminStatus;
      return status ? status.daysUntilInactive : null;
    },
    isAcademyInherited() {
      return !!this.$store.state.academyAdminStatus?.inheritedSubscription;
    },
  },
  created() {
    if (this.$store.state.managedAcademy) {
      this.initHomeData(); // Move your current created() logic into a method
    }
  },
  methods: {
    initHomeData() {
      this.getWelcomeMessage();
      if (this.$store.state.managedAcademy) {
        Api2()
          .get(
            "admins/academy/" +
            this.$store.state.managedAcademy +
            "/admin/" +
            this.$store.state.user._id +
            "/permissions"
          )
          .then((response) => {
            this.$store.dispatch("setPermissions", response.data.permissions);
          });
      }
      Api2()
        .get("admins/academy/" + this.$store.state.managedAcademy + "/is_admin")
        .then((response) => {
          const data = response.data;
          if (data) {
            if (data.language) {
              this.$store.dispatch("setLanguage", data.language);
              this.$i18n.locale = data.language;
            }
          }
        }).catch((err) => {
          console.log('Error checkin is_admin on App: ', err)
          //Clear some stuff and send back to select academy
          this.$store.dispatch("setManagedAcademy", null);
          this.navigateTo({ name: "noacademy" });
        });
      Api2()
        .get("admins/academy/" + this.$store.state.selectedAcademy)
        .then((response) => {
          if (response.data) {
            this.academyName = response.data.name;
            this.academyAffiliation = response.data.affiliation;
            this.currencySymbol = response.data.currencySymbol;
            this.$store.dispatch("setNotificationsCount", response.data.notificationsCount);
            this.loadHomeData();
          }
        });
      this.getVideos();
    },
    getVideos() {
      Api2()
        .get("videos/admins/" + this.$store.state.managedAcademy + '/titles/all')
        .then(response => {
          const data = response.data;
          if (data.videos && data.videos.length > 0) {
            this.videos = data.videos;
          }
        });
    },
    removePostImage() {
      this.socialPost.image = null;
      this.socialPostImage = null;
    },
    async uploadNewImage(event) {
      if (event.target.files[0]) {
        this.uploadingImage = true;
        const vm = this;
        const selectedFile = event.target.files[0];
        const size = event.target.files[0].size;
        const sizeMb = Math.floor(size / 1000000);
        if (sizeMb <= 15) {
          const formData = new FormData();
          const d = new Date();
          const millis = d.getTime();
          const imgExtension = selectedFile.type.toLowerCase().split('/')[1];
          const blob = new Blob([selectedFile], { type: selectedFile.type });
          formData.append("image", blob, 'bjjlink-user-admin-uploaded-image-' + millis + '.' + imgExtension);

          Api2().post("content/image/admin", formData)
            .then(res => {
              if (res) {
                setTimeout(function () {
                  const newImage = res.data.location;
                  vm.socialPost.image = newImage;
                  vm.socialPostImage = res.data.original;
                  vm.uploadingImage = false;
                }, 4000);
              }
            })
            .catch(err => {
              this.uploadingImage = false;
              if (err)
                this.showAlert('error', this.$t('message.oops_not_working'));
            });
        } else {
          this.uploadingImage = false;
          this.showAlert(
            "error",
            "Sorry! Your image is too big (" +
            sizeMb +
            "mb), try a smaller one."
          );
        }
      } else {
        this.uploadingImage = false;
      }
    },
    addPostImage() {
      const imageFileBtn = this.$refs.addPostImageEl;
      if (imageFileBtn) {
        imageFileBtn.click();
      }
    },
    refreshRecentTransactions() {
      this.loadingTransactions = true;
      Api2()
        .get("admins/academy/" + this.$store.state.managedAcademy + "/home/recent/transactions")
        .then((response) => {
          const data = response.data;
          if (data && data.transactions) {
            this.currency = data.currency;
            if (data.transactions && data.transactions.length > 0) {
              this.recentTransactions = data.transactions;
            }
          }
          this.loadingTransactions = false;
        });
    },
    loadHomeData() {
      if (this.$store.state.managedAcademy) {
        this.updateNotificationsCount();
        Api2()
          .get("admins/academy/" + this.$store.state.managedAcademy + "/home/members")
          .then((response) => {
            const data = response.data;
            if (data && data.members) {
              this.newMembers = data.members.newMembers;
              this.memberStats = {
                total: data.members.totalThisMonth
              }
            }
          });
        Api2()
          .get("admins/academy/" + this.$store.state.managedAcademy + "/home/attendance")
          .then((response) => {
            const data = response.data;
            if (data && data.checkins) {
              this.lastCheckins = data.checkins.lastCheckins;
              this.checkinStats = {
                percent: data.checkins.checkinChangePercent,
                today: data.checkins.checkinsThisMonth,
                lastMonth: data.checkins.checkinsLastMonth
              };
            }
          });
        this.refreshRecentTransactions();
        this.loadIncome();
        Api2()
          .get("admins/academy/" + this.$store.state.managedAcademy + "/home/demographics")
          .then((response) => {
            if (response.data && response.data.demographics) {
              const data = response.data.demographics;
              //Types
              let options = {
                colors: [this.themeColor('secondary'), this.themeColor('error')],
                theme: {
                  mode: this.isDarkMode() ? 'dark' : 'light',
                },
                chart: {
                  background: 'none'
                },
                legend: {
                  position: 'right'
                },
                tooltip: {
                  enabled: true,
                  fillSeriesColor: false,
                },
                stroke: {
                  show: false
                },
                labels: [this.$t("message.adults"), this.$t("message.minors")]
              };
              this.typesGraph = {
                data: [data.types.adult, data.types.minor],
                options: options
              };

              //Belts
              const belts = this.orderedBelts();
              let colors = [];
              let graphData = [];
              let labels = [];
              let labelColors = [];
              belts.forEach((belt) => {
                if (data.belts[belt] > 0) {
                  if (belt == 'white') {
                    colors.push('#F5F5F5');
                    labelColors.push('#757575');
                  } else if (belt == 'blue' || belt == 'purple' || belt == 'brown' || belt == 'black') {
                    colors.push(this.themeColor(belt));
                    labelColors.push('#BDBDBD');
                  } else {
                    colors.push(this.themeColor(belt));
                    labelColors.push('#757575');
                  }
                  graphData.push(data.belts[belt]);
                  labels.push(this.$t("message." + belt));
                }
              });
              options = {
                colors: colors,
                theme: {
                  mode: this.isDarkMode() ? 'dark' : 'light',
                },
                chart: {
                  background: 'none',
                  toolbar: {
                    show: false
                  },
                },
                plotOptions: {
                  bar: {
                    barHeight: '70%', // increase the bar height to 50px
                    borderRadius: 5,
                    distributed: true,
                    horizontal: true,
                    dataLabels: {
                      position: 'bottom'
                    },
                  }
                },
                grid: {
                  show: false,
                },
                xaxis: {
                  categories: labels,
                  labels: {
                    show: false,
                  },
                  axisBorder: {
                    show: false,
                  },
                  axisTicks: {
                    show: false,
                  },
                },
                yaxis: {
                  labels: {
                    show: false
                  },
                },
                legend: { show: false },
                dataLabels: {
                  enabled: true,
                  textAnchor: 'start',
                  offsetX: 10,
                  style: {
                    colors: labelColors
                  },
                  formatter: function (val, opt) {
                    return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val
                  },
                },
                tooltip: {
                  fillSeriesColor: false,
                  x: {
                    show: true
                  },
                  y: {
                    title: {
                      formatter: function () {
                        return ''
                      }
                    }
                  }
                }
              };
              this.beltsGraph = {
                data: [{ data: graphData }],
                options: options
              };
            }
          });
        Api2()
          .get("admins/academy/" + this.$store.state.managedAcademy + "/home/mei")
          .then((response) => {
            const data = response.data;
            this.meiData = {
              avgMei: data && data.avgMei != null ? data.avgMei : null,
              topPerformers: data && data.topPerformers ? data.topPerformers : [],
            };
            if (this.meiData.avgMei !== null) {
              this.meiChartOptions = {
                chart: { type: 'radialBar', background: 'none' },
                plotOptions: {
                  radialBar: {
                    startAngle: -135,
                    endAngle: 135,
                    hollow: { size: '60%' },
                    track: { background: this.isDarkMode() ? '#424242' : '#E0E0E0' },
                    dataLabels: {
                      name: { show: true, offsetY: -10, fontSize: '11px', color: '#9E9E9E' },
                      value: {
                        show: true,
                        fontSize: '28px',
                        fontWeight: 'bold',
                        formatter: function (val) { return Math.round(val); }
                      }
                    }
                  }
                },
                fill: { colors: [this.meiColor(this.meiData.avgMei)] },
                stroke: { lineCap: 'round' },
                labels: ['Avg MEI'],
                theme: { mode: this.isDarkMode() ? 'dark' : 'light' }
              };
            }
          })
          .catch(() => {
            this.meiData = { avgMei: null, topPerformers: [] };
          });
      }
    },
    loadIncome() {
      this.loadingIncome = true;
      Api2()
        .get("admins/academy/" + this.$store.state.managedAcademy + "/home/finances?months=2")
        .then((response) => {
          const data = response.data;
          if (data && data.incomeByMonth) {
            const month = Object.keys(data.incomeByMonth)[0];
            if (month) {
              const thisMonthData = data.incomeByMonth[month];
              const income = thisMonthData.retail + thisMonthData.membership + thisMonthData.event;
              if (income != 0)
                this.incomeThisMonth = Math.round(income);
              if (data.lastXMonths) {
                let categories = [];
                const totalMonths = data.lastXMonths.length;
                for (let i = totalMonths; i > 0; i--) {
                  const month = new Date();
                  month.setMonth(month.getMonth() - i);
                  categories.push(this.$d(month, "month_year", this.$i18n.locale));
                }
                this.incomeSpline.data = [
                  {
                    name: this.$t("message.income"),
                    data: data.lastXMonths
                  }
                ];
                this.incomeThisMonthLastUpdate = thisMonthData.lastUpdate;
                this.incomeSpline.options = {
                  labels: { show: false },
                  colors: [this.themeColor('graph1')],
                  xaxis: {
                    categories: categories,
                    show: false,
                    labels: {
                      show: false
                    },
                    axisBorder: {
                      show: false
                    },
                    axisTicks: {
                      show: false
                    },
                    tooltip: {
                      enabled: false
                    }
                  },
                  yaxis: {
                    labels: {
                      show: false,
                    }
                  },
                  dataLabels: {
                    enabled: false,
                  },
                  stroke: {
                    curve: 'smooth',
                    width: 3
                  },
                  theme: {
                    mode: this.isDarkMode() ? 'dark' : 'light',
                  },
                  chart: {
                    toolbar: {
                      show: false
                    },
                    background: 'none'
                  },
                  legend: {
                    show: false
                  },
                  grid: {
                    show: false
                  },
                };
              }
            }
          }
          this.loadingIncome = false;
        }).catch(() => {
          this.loadingIncome = false;
        });
    },
    goToQuickAction(action) {
      if (action == 'add_member') {
        this.navigateTo({ name: "members", query: { add_member: 'true' } });
      } else if (action == 'sell_item') {
        this.navigateTo({ name: "bulksell" });
      } else if (action == 'sell_membership') {
        this.navigateTo({ path: "/secure/plus/products/tab/1", query: { sell_membership: 'true' } });
      } else if (action == 'manual_checkin') {
        this.navigateTo({ name: "viewattendancetabs", params: { tabId: 2 } });
      } else if (action == 'view_attendance') {
        this.navigateTo({ name: "viewattendancetabs", params: { tabId: 1 } });
      } else if (action == 'view_members') {
        this.navigateTo({ name: "members" });
      } else if (action == 'referrals') {
        this.navigateTo({ name: "referrals" });
      } else if (action == 'view_transactions')
        this.navigateTo({ name: "transactions" });
      else if (action == 'add_event')
        this.navigateTo({
          name: this.$store.state.adminPlusVersion
            ? "manageacademyeventplus"
            : "manageacademyevent",
          params: { eventId: 'new' }
        });
      else if (action == 'add_expense')
        this.navigateTo({ name: "manageexpense-adminplus", params: { transactionId: 'new' } });
    },
    addPollAnswer() {
      if (this.poll && this.poll.answers && this.poll.answers.length < 5) {
        this.poll.answers.push('');
      }
    },
    showOptions(option) {
      this.createPoll = false;
      this.addPostVideo = false;
      this.addPostEvent = false;
      if (option == 'poll') {
        this.createPoll = !this.createPoll;
      } else if (option == 'video') {
        this.addPostVideo = !this.addPostVideo;
        this.createPoll = false;
      } else if (option == 'event') {
        this.addPostEvent = !this.addPostEvent;
        this.loadingEvents = true;
        Api2()
          .get(
            "calendar/admin/academy/" +
            this.$store.state.managedAcademy +
            "/events/public?futrue=yes&classes=yes"
          )
          .then((response) => {
            const data = response.data;
            if (data) {
              if (data.events && data.events.length > 0)
                this.availableEvents = data.events;
            }
            this.loadingEvents = false;
          });
      } else {
        this.createPoll = false;
        this.addPostVideo = false;
        this.addPostEvent = false;
      }
    },
    displaySocialPostDialog() {
      this.socialPost = {}
      this.socialPostDialog = true;
    },
    closeSocialPostDialog() {
      this.socialPostDialog = false;
      this.socialPost = null;
    },
    submitSocialPost() {
      if (this.socialPost) {
        if (!this.socialPost.contents) {
          this.showAlert("error", "Oops!", this.$t("message.fill_all_params"));
          return;
        }
        if (this.poll && this.poll.answers.length > 1)
          this.socialPost.poll = this.poll;
        Api2()
          .post(
            "admins/academy/" +
            this.$store.state.managedAcademy +
            "/posts/social", this.socialPost
          )
          .then((response) => {
            const data = response.data;
            if (data) {
              this.socialPostDialog = false;
              this.socialPost = null;
              this.selectedMember = null;
              this.showAlert("success", this.$t("message.success"));
              this.poll = {
                answers: ['', '']
              };
              this.createPoll = false;
              this.addPostVideo = false;
            }
          })
          .catch((e) => {
            this.loading = false;
            if (e)
              this.showAlert("error", "Oops!", this.$t("message.error_generic"));
          });
      }
    },
    meiColor(score) {
      if (score === null || score === undefined) return '#9E9E9E';
      if (score >= 80) return this.themeColor('success');
      if (score <= 20) return this.themeColor('error');
      const t = (score - 20) / 60;
      const r = Math.round(244 + (76 - 244) * t);
      const g = Math.round(67 + (175 - 67) * t);
      const b = Math.round(54 + (80 - 54) * t);
      return 'rgb(' + r + ',' + g + ',' + b + ')';
    },
    getWelcomeMessage() {
      let today = new Date();
      let hourNow = today.getHours();
      if (hourNow < 12) {
        this.greetingTime = "morning";
      }
      else if (hourNow < 20) {
        this.greetingTime = 'afternoon';
      }
      else if (hourNow < 24) {
        this.greetingTime = "evening"
      }
      else {
        this.greetingTime = "morning";
      }

    }
  },
};
</script>

<style scoped>
.demographics-card {
  overflow-x: scroll;
}

.member-avatar {
  border: 1px solid gray
}

.theme--light .action-card-main {
  margin-top: 12px;
  background-color: #ffffff !important;
  border-top: 1px solid rgba(0, 0, 0, 0.10) !important
}

.theme--dark .action-card-main {
  background-color: #333333;
}
</style>
